<template>
  <div>
    <el-dialog
      :title="`新增补单(原订单:${originalOrder.orderNumber})`"
      :visible.sync="visible"
      width="60%"
      :close-on-press-escape="false">
      <el-button
        type="primary"
        :loading="loading"
        @click="addProduct">选择商品</el-button>
      <el-form
        ref="ruleForm"
        label-position="top"
        :model="outstock"
        label-width="80px"
        :rules="rules">
        <el-form-item
          label="订单号:"
          prop="orderNumber">
          <el-input v-model="outstock.orderNumber"></el-input>
        </el-form-item>
        <el-form-item
          label-width="0"
          prop="productItems">
          <el-table
            v-loading="loading"
            :data="outstock.productItems"
            border>
            <el-table-column
              label="商品名称"
              prop="productName"></el-table-column>
            <el-table-column
              label="商品类型"
              prop="categoryName"></el-table-column>
            <el-table-column label="数量">
              <template slot-scope="{$index}">
                <el-form-item
                  label-width="0"
                  :prop="'productItems.' + $index + '.goodsCount'"
                  :rules="[{required: true, message: '请输入数量', trigger: 'blur'}]">
                  <el-input-number
                    v-model="outstock.productItems[$index].goodsCount"
                    :precision="0"
                    :min="1"></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          :loading="loading"
          @click="toggleModal(false)">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <product-select-modal
      ref="modal"
      :option="{vendorId: $route.query.vendorId}"
      @update:list="updateProductItems" />
  </div>
</template>
<script>
import ProductSelectModal from './product-select-modal.vue'
export default {
  name: 'DistributionModal',
  components: { ProductSelectModal },
  props: {
    originalOrder: {
      type: Object,
      default() {
        return {
          outstockOrderId: ''
        }
      }
    },
    fetch: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      outstock: {
        orderNumber: '',
        productItems: []
      },
      rules: {
        productItems: [
          { type: 'array', required: true, message: '请选择商品', trigger: 'change' }
        ]
      }
    }
  },
  computed: {},
  watch: {
    'originalOrder.outstockOrderId': {
      handler(val) {
        if (val) {
          this.$refs.modal.reset()
        }
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
      if (!visible) {
        this.$refs.modal.reset()
        this.outstock.productItems = []
        this.outstock.orderNumber = ''
      }
    },
    addProduct() {
      this.$refs.modal.toggleModal(true)
    },
    updateProductItems(list) {
      this.outstock.productItems = list
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('outstock/addoutstockorder', {
            payload: {
              vendorId: this.$route.query.vendorId,
              originalOrderId: this.originalOrder.outstockOrderId,
              deliveryAddressId: this.originalOrder.deliveryAddressId,
              orderNumber: this.outstock.orderNumber,
              productItems: this.outstock.productItems.map(i => ({ productId: i.productId, goodsCount: i.goodsCount }))
            },
            success: () => {
              this.loading = false
              this.fetch && this.fetch()
              this.$refs.modal.reset()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
